import type { ReactNode } from 'react';
import { useSession } from '../state/session';
import { Icon } from './Icon';

interface TagChipProps {
  tag: string;
  onRemove?: () => void;
  extra?: ReactNode;
}

/** `#tag` pill colored by category (prototype `chipHTML`). */
export function TagChip({ tag, onRemove, extra }: TagChipProps) {
  const { tagIndex } = useSession();
  return (
    <span className={`chip cat-${tagIndex.catOf(tag)}`}>
      #{tag}
      {extra}
      {onRemove && (
        <button
          type="button"
          aria-label={`Remove ${tag}`}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        >
          <Icon name="x" />
        </button>
      )}
    </span>
  );
}
